import {Component, ViewChild} from "@angular/core";
import {PromocionesService} from "../../../core/promociones/promociones.service";
import {PromocionInfo} from "../../../core/promociones/promocion-info";
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import {ActivationModalComponent} from "./activation-modal-component";
import {MessageService} from "primeng/components/common/messageservice";
import {ActivatedRoute, Router} from "@angular/router";
import {PrincipalModalComponent} from "./principal-modal-component";
import {Environment} from "../../../core/environment-core";
declare var $;
@Component({
    selector: 'app-promociones',
    templateUrl: './promociones.component.html',
    styleUrls: ['./promociones.component.scss']
})
export class PromocionesComponent {

    promociones: PromocionInfo[] = [];
    @ViewChild('inputCodes')
    inputCodes: any;
    loading = true;
    loadingCodes = false;
    promotionKey: string;
    promotionType = 'quantum';

    constructor(private promocionesService: PromocionesService,
                private router: Router,
                private modalService: NgbModal,
                private route: ActivatedRoute,
                private messageService: MessageService,
                public environment: Environment) {
        promocionesService.getPromociones(this.promotionType).subscribe((promociones) => {
            this.promociones = promociones;
            this.loading = false;
        }, error => {
            this.loading = false;
        });
    }

    open(promocion) {
        const modalRef = this.modalService.open(ActivationModalComponent, {backdrop: 'static'});
        modalRef.componentInstance.promocion = promocion;
        modalRef.result.then((result) => {
            // this.closeResult = `Closed with: ${result}`;
            console.log(result);
        }, (reason) => {
            // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            console.log(reason);
        });
    }

    downloadErrorCodes(promotionKey) {
        this.promocionesService.downloadErrorCodes(promotionKey).subscribe((data) => {
            this.downloadFile(data, promotionKey);
        }, (error) => {
            console.log("Error downloading the file");
        });
    }

    downloadFile(blob, promotionKey) {
        const url = window.URL.createObjectURL(blob);
        const anchorElem = document.createElement("a");
        anchorElem.style.display = "none";
        anchorElem.href = url;
        anchorElem.download = `${promotionKey}-codes-error.csv`;

        document.body.appendChild(anchorElem);
        anchorElem.click();

        document.body.removeChild(anchorElem);

        // On Edge, revokeObjectURL should be called only after
        // a.click() has completed, atleast on EdgeHTML 15.15048
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 1000);
    }

    addPromotion() {
        this.router.navigate(['/ganalottodo/adminPromotionComponent/new']);
    }

    editPromotion(key: string) {
        this.router.navigate(['/ganalottodo/adminPromotionComponent/' + key]);
    }

    openPrincipalModal(promocion: PromocionInfo) {
        const modalRef = this.modalService.open(PrincipalModalComponent, {backdrop: 'static'});
        modalRef.componentInstance.promocion = promocion;
        modalRef.componentInstance.promociones = this.promociones;
        modalRef.result.then((result) => {
            console.log(result);
        }, (reason) => {
            console.log(reason);
        });
    }

    uploadCodes(formData) {
        console.log('PromocionesComponent#uploadCodes');
        console.log(formData.get('file'));
        this.loadingCodes = true;
        this.promocionesService.uploadCodesPromotion(formData).subscribe(
            (code) => {
                this.loadingCodes = false;
                this.messageService.add({
                    severity: 'success',
                    summary: '',
                    detail: 'Se cargaron codigos correctamente'
                });
            },
            (err) => {
                this.loadingCodes = false;
                console.log('PromocionesComponent#uploadCodes:error');
                console.log(err);
                this.processError(err.error);
            });
    }

    fileCodesUpload(event) {
        const fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            const file: File = fileList[0];
            if (file.size > 0) {
                console.log('File Size');
                console.log(file.size);
                const formData: FormData = new FormData();
                formData.append('file', file, file.name);
                formData.append('promotionKey', this.promotionKey);
                formData.append('promotionType', null);
                formData.append('numeroCodigos', null);
                console.log('PromocionesComponent#fileCodesUpload:fileName');
                console.log(file.name);
                console.log(formData.get('file'));
                this.uploadCodes(formData);
            } else {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Archivo de codigos vacio'
                });
            }
        }
        this.inputCodes.nativeElement.value = "";
    }

    upFile(inputid, promotionKey) {
        this.promotionKey = promotionKey;
        $("#" + inputid).prop('type', 'file');
        $("#" + inputid).trigger('click');
    }

    showDetails(promocion: PromocionInfo) {
        ///promotions/:type/:promotionKey
        this.router.navigate(['/ganalottodo/promotions/' + this.promotionType + '/' + promocion.promotionKey]);
    }

    processError(error) {
        switch (error) {
            case 'CodesAlreadyExist':
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Algunos códigos ya encuentran registrados. Verifique e intente de nuevo'
                });
                break;
            default:
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Ocurrio un error en la carga de códigos'
                });
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/promociones.component.ts